import MetricBase from "models/metrics/MetricBase";
import ConnectivityGroup from "models/groups/ConnectivityGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricHotelSuspendedCount extends MetricBase {
    constructor() {
        super({
            field: "metric_hotelSuspendedCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.hotelSuspendedCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.hotelSuspendedCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.hotelSuspendedCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricHotelSuspendedCount;
